import React from "react";

import PropTypes from "prop-types";

import getSlugPartsTitle from "../../utils/getSlugPartsTitle";
import SEO from "../seo/seo";

// eslint-disable-next-line import/prefer-default-export
export const GatsbyHead = ({
  data: { page },
  isHiddenForRobots: isHiddenForRobotsProp = null,
  linkingData = null,
  title = null,
  headerImage = null,
  useFallbackLevel = false,
}) => {
  let defaultHeaderImage = headerImage;

  if (!defaultHeaderImage) {
    defaultHeaderImage = [];

    if (page.elements.hero_image && page.elements.hero_image.value.length > 0) {
      if (page.elements.hero_image.value[0].system?.type === "image"
        && page.elements.hero_image.value[0].elements.image.value.length > 0) {
        defaultHeaderImage = page.elements.hero_image.value[0].elements.image.value;
      } else if (page.elements.hero_image.value[0].system?.type === "video"
        && page.elements.hero_image.value[0].elements.placeholder_image.value.length > 0) {
        defaultHeaderImage = page.elements.hero_image.value[0].elements.placeholder_image.value;
      }
    }
  }

  let isHiddenForRobots = false;

  if (isHiddenForRobotsProp !== null) {
    // Overwrite from code if set
    isHiddenForRobots = isHiddenForRobotsProp;
  } else if (page.elements.meta_robots__noindex) {
    // if Kontent value available overwrite
    isHiddenForRobots = page.elements.meta_robots__noindex.value.length > 0;
  }

  return (
    <SEO
      title={title || page.elements.metadata__meta_title.value}
      description={page.elements.metadata__meta_description.value}
      twitterTitle={page.elements.metadata__twitter_title.value}
      twitterSite={page.elements.metadata__twitter_site.value}
      twitterImage={page.elements.metadata__twitter_image.value.length > 0
        ? page.elements.metadata__twitter_image.value
        : defaultHeaderImage}
      twitterDescription={page.elements.metadata__twitter_description.value}
      twitterCreator={page.elements.metadata__twitter_creator.value}
      ogTitle={page.elements.metadata__og_title.value}
      ogImage={page.elements.metadata__og_image.value.length > 0
        ? page.elements.metadata__og_image.value
        : defaultHeaderImage}
      ogDescription={page.elements.metadata__og_title.value}
      isHiddenForRobots={isHiddenForRobots}
      linkingData={linkingData}
      tag={getSlugPartsTitle(page.id, useFallbackLevel)}
    />
  );
};

GatsbyHead.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
  headerImage: PropTypes.arrayOf(PropTypes.string),
  isHiddenForRobots: PropTypes.bool,
  linkingData: PropTypes.arrayOf(PropTypes.shape({})),
  title: PropTypes.string,
  useFallbackLevel: PropTypes.bool,
};
